// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.orgchart ul {
  padding-left: 0;
  text-align: center;
  display: flex;
  margin: 0;
  transition: transform 0.3s, opacity 0.3s;
}

.orgchart ul li {
  display: inline-block;
  position: relative;
}

/* excluding root node */
.orgchart > ul > li > ul li::before {
  content: "";
  position: absolute;
  top: -11px;
  left: 0;
  width: 100%;
  border-top: 2px solid rgba(217, 83, 79, 0.8);
  box-sizing: border-box;
}

.orgchart > ul > li > ul li.isSiblingsCollapsed::before {
  content: none;
}

.orgchart > ul > li > ul li:first-child::before {
  left: calc(50% - 1px);
  width: calc(50% + 1px);
}

.orgchart > ul > li > ul li:last-child::before {
  width: calc(50% + 1px);
}

.orgchart > ul > li > ul li:only-child::before {
  width: 2px;
}
.orgchart ul li .oc-node {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  padding: 3px;
  border: 2px dashed transparent;
  margin-bottom: 20px;
}
.orgchart ul li .oc-node.allowedDrop {
  border-color: rgba(68, 157, 68, 0.9);
}
.orgchart ul li .oc-node.currentDropTarget {
  background-color: rgba(68, 157, 68, 0.9);
}
.orgchart ul li .oc-node.selected {
  background-color: rgba(238, 217, 54, 0.5);
}
.orgchart ul li .oc-node:hover {
  background-color: rgba(238, 217, 54, 0.5);
}
/* excluding root node */
.orgchart > ul > li > ul li > .oc-node::before {
  content: "";
  position: absolute;
  top: -11px;
  left: calc(50% - 1px);
  width: 2px;
  height: 9px;
  background-color: rgba(217, 83, 79, 0.8);
}

.orgchart > ul > li > ul li.isSiblingsCollapsed > .oc-node::before {
  top: -13px;
  height: 11px;
}

.orgchart > ul > li > ul li.isAncestorsCollapsed > .oc-node::before {
  content: none;
}

/* excluding leaf node */
.orgchart ul li .oc-node:not(:only-child)::after {
  content: "";
  position: absolute;
  bottom: -11px;
  left: calc(50% - 1px);
  width: 2px;
  height: 9px;
  background-color: rgba(217, 83, 79, 0.8);
}

.orgchart ul li .oc-node.isChildrenCollapsed:not(:only-child)::after {
  content: none;
}

.orgchart ul li .oc-node .oc-heading {
  box-sizing: border-box;
  padding: 2px;
  margin: 0;
  width: 130px;
  height: 20px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: rgba(217, 83, 79, 0.8);
  color: #fff;
  border-radius: 4px 4px 0 0;
}

.orgchart ul li .oc-node .oc-heading .oc-symbol {
  float: left;
  margin-top: 12px;
  margin-left: 2px;
}

.orgchart ul li .oc-node .oc-heading .oc-symbol::before {
  background-color: #fff;
  border-color: rgba(217, 83, 79, 0.8);
}

.orgchart ul li .oc-node .oc-heading .oc-symbol::after {
  background-color: #fff;
}

.orgchart ul li .oc-node .oc-content {
  box-sizing: border-box;
  padding: 2px;
  width: 130px;
  height: 20px;
  font-size: 0.625rem;
  border: 1px solid rgba(217, 83, 79, 0.8);
  border-radius: 0 0 4px 4px;
  text-align: center;
  background-color: #fff;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* styles for edges */
.orgchart .oc-node .oc-edge {
  position: absolute;
  cursor: default;
  transition: .2s;
}

.orgchart .oc-node .oc-edge::before {
  border-color: rgba(68, 157, 68, 0.5);
}

.orgchart.noncollapsable .oc-node .oc-edge {
  display: none;
}

.orgchart .oc-node .oc-edge:hover {
  cursor: pointer;
}

.orgchart .oc-edge:hover::before {
  border-color: #449d44;
}

.orgchart .oc-node .verticalEdge {
  width: calc(100% - 6px);
  width: -moz-calc(100% - 6px);
  height: 10px;
  left: 3px;
}

.orgchart .oc-node .verticalEdge::before {
  position: absolute;
  left: calc(50% - 0.3125rem);
}

.orgchart .oc-node .topEdge {
  top: -2px;
}

.orgchart .oc-node .topEdge.oci-chevron-up::before {
  top: 2px;
}

.orgchart .oc-node .topEdge.oci-chevron-down::before {
  bottom: 3px;
}

.orgchart .oc-node .bottomEdge {
  bottom: -2px;
}

.orgchart .oc-node .bottomEdge.oci-chevron-up::before {
  bottom: -3px;
}

.orgchart .oc-node .bottomEdge.oci-chevron-down::before {
  bottom: 1px;
}

.orgchart .oc-node .horizontalEdge {
  width: 10px;
  height: calc(100% - 6px);
  height: -moz-calc(100% - 6px);
  top: 3px;
}

.orgchart .oc-node .rightEdge {
  right: -2px;
}

.orgchart .oc-node .leftEdge {
  left: -2px;
}

.orgchart .oc-node .horizontalEdge::before {
  position: absolute;
  top: calc(50% - 0.3125rem);
}

.orgchart .oc-node .rightEdge.oci-chevron-left::before {
  right: -3px;
}

.orgchart .oc-node .rightEdge.oci-chevron-right::before {
  right: 1px;
}

.orgchart .oc-node .leftEdge.oci-chevron-right::before {
  left: -3px;
}

.orgchart .oc-node .leftEdge.oci-chevron-left::before {
  left: 1px;
}

/* slide animations */
.orgchart .slide-up {
  opacity: 0;
  transform: translateY(-40px);
}

.orgchart .slide-down {
  opacity: 0;
  transform: translateY(40px);
}

.orgchart .slide-left {
  opacity: 0;
  transform: translateX(-130px);
}

.orgchart .slide-right {
  opacity: 0;
  transform: translateX(130px);
}

/* oci means organization chart icons */
.oci {
  display: inline-block;
  position: relative;
  font-style: normal;
  font-family: Arial;
}

.oci-chevron-up::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  vertical-align: text-bottom;
  width: 0.625rem;
  height: 0.625rem;
  border-width: 0 0.2rem 0.2rem 0;
  border-style: solid;
  border-color: #000;
  background: transparent;
  transform: rotate(-135deg);
}

.oci-chevron-right::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  width: 0.625rem;
  height: 0.625rem;
  border-width: 0 0.2rem 0.2rem 0;
  border-style: solid;
  border-color: #000;
  background: transparent;
  transform: rotate(-45deg);
}

.oci-chevron-down::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  width: 0.625rem;
  height: 0.625rem;
  border-width: 0 0.2rem 0.2rem 0;
  border-style: solid;
  border-color: #000;
  background: transparent;
  transform: rotate(45deg);
}

.oci-chevron-left::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  width: 0.625rem;
  height: 0.625rem;
  border-width: 0 0.2rem 0.2rem 0;
  border-style: solid;
  border-color: #000;
  background: transparent;
  transform: rotate(135deg);
}

.oci-leader::before {
  position: absolute;
  content: "";
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  background: #000;
  top: -0.75rem;
  left: 0.125rem;
}

.oci-leader::after {
  position: absolute;
  content: "";
  display: inline-block;
  width: 0.875rem;
  height: 0.375rem;
  border-radius: 0.25rem 0.25rem 0 0;
  background: #000;
  top: -0.3rem;
  left: -0.125rem;
}

.oci-plus-square::before {
  content: "+";
  display: inline-block;
  vertical-align: text-bottom;
  text-align: center;
  width: 1rem;
  height: 1rem;
  background-color: #000;
  color: #fff;
}

.oci-plus-circle::before {
  content: "+";
  display: inline-block;
  vertical-align: text-bottom;
  text-align: center;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: #000;
  color: #fff;
}

.oci-minus-square::before {
  content: "−";
  display: inline-block;
  vertical-align: text-bottom;
  text-align: center;
  width: 1rem;
  height: 1rem;
  background-color: #000;
  color: #fff;
}

.oci-minus-circle::before {
  content: "−";
  display: inline-block;
  vertical-align: text-bottom;
  text-align: center;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: #000;
  color: #fff;
}

.oci-arrow-circle-up::before {
  content: "▲";
  display: inline-block;
  text-align: center;
  vertical-align: text-bottom;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: #000;
  color: #fff;
  font-size: 0.875rem;
}

.oci-arrow-circle-down::before {
  content: "▼";
  text-align: center;
  display: inline-block;
  vertical-align: text-bottom;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: #000;
  color: #fff;
  font-size: 0.875rem;
}

.oci-info-circle::before {
  content: "i";
  display: inline-block;
  vertical-align: text-bottom;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background-color: #000;
  color: #fff;
  text-align: center;
  font-weight: bold;
}

.oci-spinner::before {
  content: "";
  vertical-align: text-bottom;
  display: inline-block;
  box-sizing: border-box;
  width: 1rem;
  height: 1rem;
  border: 0.1rem solid #000;
  border-right-color: transparent;
  border-radius: 0.625rem;
  animation: oci-infinite-spinning .75s linear infinite;
}

@keyframes oci-infinite-spinning {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@dabeng/react-orgchart/dist/ChartNode.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EAEvB,4BAA4B;EAC5B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EAExB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["\n.orgchart ul {\n  padding-left: 0;\n  text-align: center;\n  display: flex;\n  margin: 0;\n  transition: transform 0.3s, opacity 0.3s;\n}\n\n.orgchart ul li {\n  display: inline-block;\n  position: relative;\n}\n\n/* excluding root node */\n.orgchart > ul > li > ul li::before {\n  content: \"\";\n  position: absolute;\n  top: -11px;\n  left: 0;\n  width: 100%;\n  border-top: 2px solid rgba(217, 83, 79, 0.8);\n  box-sizing: border-box;\n}\n\n.orgchart > ul > li > ul li.isSiblingsCollapsed::before {\n  content: none;\n}\n\n.orgchart > ul > li > ul li:first-child::before {\n  left: calc(50% - 1px);\n  width: calc(50% + 1px);\n}\n\n.orgchart > ul > li > ul li:last-child::before {\n  width: calc(50% + 1px);\n}\n\n.orgchart > ul > li > ul li:only-child::before {\n  width: 2px;\n}\n.orgchart ul li .oc-node {\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n  padding: 3px;\n  border: 2px dashed transparent;\n  margin-bottom: 20px;\n}\n.orgchart ul li .oc-node.allowedDrop {\n  border-color: rgba(68, 157, 68, 0.9);\n}\n.orgchart ul li .oc-node.currentDropTarget {\n  background-color: rgba(68, 157, 68, 0.9);\n}\n.orgchart ul li .oc-node.selected {\n  background-color: rgba(238, 217, 54, 0.5);\n}\n.orgchart ul li .oc-node:hover {\n  background-color: rgba(238, 217, 54, 0.5);\n}\n/* excluding root node */\n.orgchart > ul > li > ul li > .oc-node::before {\n  content: \"\";\n  position: absolute;\n  top: -11px;\n  left: calc(50% - 1px);\n  width: 2px;\n  height: 9px;\n  background-color: rgba(217, 83, 79, 0.8);\n}\n\n.orgchart > ul > li > ul li.isSiblingsCollapsed > .oc-node::before {\n  top: -13px;\n  height: 11px;\n}\n\n.orgchart > ul > li > ul li.isAncestorsCollapsed > .oc-node::before {\n  content: none;\n}\n\n/* excluding leaf node */\n.orgchart ul li .oc-node:not(:only-child)::after {\n  content: \"\";\n  position: absolute;\n  bottom: -11px;\n  left: calc(50% - 1px);\n  width: 2px;\n  height: 9px;\n  background-color: rgba(217, 83, 79, 0.8);\n}\n\n.orgchart ul li .oc-node.isChildrenCollapsed:not(:only-child)::after {\n  content: none;\n}\n\n.orgchart ul li .oc-node .oc-heading {\n  box-sizing: border-box;\n  padding: 2px;\n  margin: 0;\n  width: 130px;\n  height: 20px;\n  text-align: center;\n  font-size: 0.75rem;\n  font-weight: bold;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background-color: rgba(217, 83, 79, 0.8);\n  color: #fff;\n  border-radius: 4px 4px 0 0;\n}\n\n.orgchart ul li .oc-node .oc-heading .oc-symbol {\n  float: left;\n  margin-top: 12px;\n  margin-left: 2px;\n}\n\n.orgchart ul li .oc-node .oc-heading .oc-symbol::before {\n  background-color: #fff;\n  border-color: rgba(217, 83, 79, 0.8);\n}\n\n.orgchart ul li .oc-node .oc-heading .oc-symbol::after {\n  background-color: #fff;\n}\n\n.orgchart ul li .oc-node .oc-content {\n  box-sizing: border-box;\n  padding: 2px;\n  width: 130px;\n  height: 20px;\n  font-size: 0.625rem;\n  border: 1px solid rgba(217, 83, 79, 0.8);\n  border-radius: 0 0 4px 4px;\n  text-align: center;\n  background-color: #fff;\n  color: #333;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* styles for edges */\n.orgchart .oc-node .oc-edge {\n  position: absolute;\n  cursor: default;\n  transition: .2s;\n}\n\n.orgchart .oc-node .oc-edge::before {\n  border-color: rgba(68, 157, 68, 0.5);\n}\n\n.orgchart.noncollapsable .oc-node .oc-edge {\n  display: none;\n}\n\n.orgchart .oc-node .oc-edge:hover {\n  cursor: pointer;\n}\n\n.orgchart .oc-edge:hover::before {\n  border-color: #449d44;\n}\n\n.orgchart .oc-node .verticalEdge {\n  width: calc(100% - 6px);\n  width: -webkit-calc(100% - 6px);\n  width: -moz-calc(100% - 6px);\n  height: 10px;\n  left: 3px;\n}\n\n.orgchart .oc-node .verticalEdge::before {\n  position: absolute;\n  left: calc(50% - 0.3125rem);\n}\n\n.orgchart .oc-node .topEdge {\n  top: -2px;\n}\n\n.orgchart .oc-node .topEdge.oci-chevron-up::before {\n  top: 2px;\n}\n\n.orgchart .oc-node .topEdge.oci-chevron-down::before {\n  bottom: 3px;\n}\n\n.orgchart .oc-node .bottomEdge {\n  bottom: -2px;\n}\n\n.orgchart .oc-node .bottomEdge.oci-chevron-up::before {\n  bottom: -3px;\n}\n\n.orgchart .oc-node .bottomEdge.oci-chevron-down::before {\n  bottom: 1px;\n}\n\n.orgchart .oc-node .horizontalEdge {\n  width: 10px;\n  height: calc(100% - 6px);\n  height: -webkit-calc(100% - 6px);\n  height: -moz-calc(100% - 6px);\n  top: 3px;\n}\n\n.orgchart .oc-node .rightEdge {\n  right: -2px;\n}\n\n.orgchart .oc-node .leftEdge {\n  left: -2px;\n}\n\n.orgchart .oc-node .horizontalEdge::before {\n  position: absolute;\n  top: calc(50% - 0.3125rem);\n}\n\n.orgchart .oc-node .rightEdge.oci-chevron-left::before {\n  right: -3px;\n}\n\n.orgchart .oc-node .rightEdge.oci-chevron-right::before {\n  right: 1px;\n}\n\n.orgchart .oc-node .leftEdge.oci-chevron-right::before {\n  left: -3px;\n}\n\n.orgchart .oc-node .leftEdge.oci-chevron-left::before {\n  left: 1px;\n}\n\n/* slide animations */\n.orgchart .slide-up {\n  opacity: 0;\n  transform: translateY(-40px);\n}\n\n.orgchart .slide-down {\n  opacity: 0;\n  transform: translateY(40px);\n}\n\n.orgchart .slide-left {\n  opacity: 0;\n  transform: translateX(-130px);\n}\n\n.orgchart .slide-right {\n  opacity: 0;\n  transform: translateX(130px);\n}\n\n/* oci means organization chart icons */\n.oci {\n  display: inline-block;\n  position: relative;\n  font-style: normal;\n  font-family: Arial;\n}\n\n.oci-chevron-up::before {\n  content: \"\";\n  display: inline-block;\n  box-sizing: border-box;\n  vertical-align: text-bottom;\n  width: 0.625rem;\n  height: 0.625rem;\n  border-width: 0 0.2rem 0.2rem 0;\n  border-style: solid;\n  border-color: #000;\n  background: transparent;\n  transform: rotate(-135deg);\n}\n\n.oci-chevron-right::before {\n  content: \"\";\n  display: inline-block;\n  box-sizing: border-box;\n  width: 0.625rem;\n  height: 0.625rem;\n  border-width: 0 0.2rem 0.2rem 0;\n  border-style: solid;\n  border-color: #000;\n  background: transparent;\n  transform: rotate(-45deg);\n}\n\n.oci-chevron-down::before {\n  content: \"\";\n  display: inline-block;\n  box-sizing: border-box;\n  width: 0.625rem;\n  height: 0.625rem;\n  border-width: 0 0.2rem 0.2rem 0;\n  border-style: solid;\n  border-color: #000;\n  background: transparent;\n  transform: rotate(45deg);\n}\n\n.oci-chevron-left::before {\n  content: \"\";\n  display: inline-block;\n  box-sizing: border-box;\n  width: 0.625rem;\n  height: 0.625rem;\n  border-width: 0 0.2rem 0.2rem 0;\n  border-style: solid;\n  border-color: #000;\n  background: transparent;\n  transform: rotate(135deg);\n}\n\n.oci-leader::before {\n  position: absolute;\n  content: \"\";\n  display: inline-block;\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 0.2rem;\n  background: #000;\n  top: -0.75rem;\n  left: 0.125rem;\n}\n\n.oci-leader::after {\n  position: absolute;\n  content: \"\";\n  display: inline-block;\n  width: 0.875rem;\n  height: 0.375rem;\n  border-radius: 0.25rem 0.25rem 0 0;\n  background: #000;\n  top: -0.3rem;\n  left: -0.125rem;\n}\n\n.oci-plus-square::before {\n  content: \"+\";\n  display: inline-block;\n  vertical-align: text-bottom;\n  text-align: center;\n  width: 1rem;\n  height: 1rem;\n  background-color: #000;\n  color: #fff;\n}\n\n.oci-plus-circle::before {\n  content: \"+\";\n  display: inline-block;\n  vertical-align: text-bottom;\n  text-align: center;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  background-color: #000;\n  color: #fff;\n}\n\n.oci-minus-square::before {\n  content: \"−\";\n  display: inline-block;\n  vertical-align: text-bottom;\n  text-align: center;\n  width: 1rem;\n  height: 1rem;\n  background-color: #000;\n  color: #fff;\n}\n\n.oci-minus-circle::before {\n  content: \"−\";\n  display: inline-block;\n  vertical-align: text-bottom;\n  text-align: center;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  background-color: #000;\n  color: #fff;\n}\n\n.oci-arrow-circle-up::before {\n  content: \"▲\";\n  display: inline-block;\n  text-align: center;\n  vertical-align: text-bottom;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  background-color: #000;\n  color: #fff;\n  font-size: 0.875rem;\n}\n\n.oci-arrow-circle-down::before {\n  content: \"▼\";\n  text-align: center;\n  display: inline-block;\n  vertical-align: text-bottom;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  background-color: #000;\n  color: #fff;\n  font-size: 0.875rem;\n}\n\n.oci-info-circle::before {\n  content: \"i\";\n  display: inline-block;\n  vertical-align: text-bottom;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 0.5rem;\n  background-color: #000;\n  color: #fff;\n  text-align: center;\n  font-weight: bold;\n}\n\n.oci-spinner::before {\n  content: \"\";\n  vertical-align: text-bottom;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 1rem;\n  height: 1rem;\n  border: 0.1rem solid #000;\n  border-right-color: transparent;\n  border-radius: 0.625rem;\n  animation: oci-infinite-spinning .75s linear infinite;\n}\n\n@keyframes oci-infinite-spinning {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
